import { Bell, Boxes, Siren, Wrench } from "lucide-react";
import { useEffect, useState } from "react";
import type { NavigationKey } from "../../app/navigation";

type NotificationCenterProps = {
  onNavigate: (key: NavigationKey) => void;
};

export function NotificationCenter({ onNavigate }: NotificationCenterProps) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [open]);

  const openDestination = (key: NavigationKey) => {
    setOpen(false);
    onNavigate(key);
  };

  return (
    <div className="dropdown-container">
      <button
        aria-expanded={open}
        aria-label="Open notifications, 3 items"
        className="icon-button notification-button"
        onClick={() => setOpen((current) => !current)}
        type="button"
      >
        <Bell aria-hidden="true" size={19} />
        <span>3</span>
      </button>
      {open && (
        <div className="dropdown-menu notification-menu" role="region" aria-label="Notifications">
          <div className="dropdown-header"><strong>Notifications</strong><small>3 current</small></div>
          <button className="dropdown-item" onClick={() => openDestination("incidents")} type="button">
            <Siren aria-hidden="true" size={19} />
            <span><strong>INC-2048 ready</strong><small>Controlled scenario can begin</small></span>
          </button>
          <button className="dropdown-item" onClick={() => openDestination("maintenance")} type="button">
            <Wrench aria-hidden="true" size={19} />
            <span><strong>7 tasks due</strong><small>Review today’s maintenance</small></span>
          </button>
          <button className="dropdown-item" onClick={() => openDestination("assets")} type="button">
            <Boxes aria-hidden="true" size={19} />
            <span><strong>18 assets need attention</strong><small>Verification or maintenance required</small></span>
          </button>
        </div>
      )}
    </div>
  );
}
